import { useEffect, useMemo, useState } from 'react';
import { useDebouncedCallback } from "use-debounce";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
    landscape: width > height,
  };
}

export default function useScreenInformation() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [hasTouchScreen] = useState(() => {
    let hasTouchScreen = false;
    if ("ontouchstart" in window) {
      if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
      } else if ("msMaxTouchPoints" in navigator) {
        // @ts-ignore
        hasTouchScreen = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = matchMedia?.("(pointer:coarse)");
        if (mQ?.media === "(pointer:coarse)") {
          hasTouchScreen = mQ.matches;
        } else if ("orientation" in window) {
          hasTouchScreen = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          // @ts-ignore
          const UA = navigator.userAgent;
          hasTouchScreen =
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA) ||
            /\b(Mobi)\b/i.test(UA);
        }
      }
    }
    return hasTouchScreen;
  })

  const handleResize = useDebouncedCallback(() => {
    const newDimensions = getWindowDimensions();
    if (newDimensions.width != windowDimensions.width &&
      newDimensions.height != windowDimensions.height) {
      setWindowDimensions(newDimensions)
    }
  }, 250)

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize)
    }
  }, []);

  return useMemo(() => ({ hasTouchScreen, ...windowDimensions }), [windowDimensions]);
}
